module.exports = __webpack_public_path__ + "img/20.b3c5b549.png";